import { Branch as DismissableLayerBranch } from '@radix-ui/react-dismissable-layer';
import { Toaster } from './sonner';

/**
 * Point de montage du toaster global : une notification reste cliquable par-dessus un
 * modal ou un menu Radix, et ce clic ne le ferme jamais.
 *
 * Deux défauts se cumulaient (modal d'import de pièces vidé de sa sélection, 2026-10-27) :
 * - un modal Radix pose `pointer-events: none` sur `body`, dont le toaster héritait : la croix
 *   d'une notification laissait passer le clic jusqu'à l'overlay, qui fermait le modal ;
 * - redevenue cliquable, la notification restait hors du modal, et Radix (`DismissableLayer`)
 *   aurait compté ce clic comme extérieur.
 *
 * `pointer-events: auto` règle le premier ; `Branch` règle le second pour toutes les couches
 * Radix, présentes et futures : un clic ou un focus dans une branche n'est jamais extérieur.
 * Le `div` n'a pas de taille (le toaster est en `position: fixed`) et n'intercepte rien.
 * `Branch` doit venir de la même version de `@radix-ui/react-dismissable-layer` que les
 * primitives (une seule dans `pnpm-lock.yaml`) : il s'inscrit dans leur contexte React.
 */
export function ToasterLayer() {
  return (
    <DismissableLayerBranch className="pointer-events-auto">
      <Toaster />
    </DismissableLayerBranch>
  );
}
